import React, { Suspense } from "react";

import { BugReportModalWithNoAv } from "./BugReportModalWithNoAv";

import { ClassSessionCategory } from "components/server-types";
import { useAppSelector } from "store/index";
import { selectActiveClassSession } from "store/selectors";

const BugReportModalWithAv = React.lazy(() =>
  import("./BugReportModalWithAv").then((mod) => ({ default: mod.BugReportModalWithAv })),
);

export const BugReportModal = ({ onClose }: { onClose: () => void }) => {
  const classSession = useAppSelector(selectActiveClassSession);
  if (classSession?.category === ClassSessionCategory.VIRTUAL) {
    return (
      <Suspense fallback={null}>
        <BugReportModalWithAv onClose={onClose} />
      </Suspense>
    );
  }
  return <BugReportModalWithNoAv onClose={onClose} />;
};
